"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.SelfServiceSchedulePane = exports.SelfServiceSchedulePaneType = void 0;
var widgets_1 = require("@tableau/widgets");
var React = require("react");
var CreateOrEditRecurrenceModelMapper_1 = require("./CreateOrEditRecurrenceModelMapper");
var RecurrenceOptionsOverlay_1 = require("./RecurrenceOptionsOverlay");
var SelfServiceSchedulePaneType;
(function (SelfServiceSchedulePaneType) {
    SelfServiceSchedulePaneType[SelfServiceSchedulePaneType["Default"] = 0] = "Default";
    SelfServiceSchedulePaneType[SelfServiceSchedulePaneType["BridgeExtractRefresh"] = 1] = "BridgeExtractRefresh";
    SelfServiceSchedulePaneType[SelfServiceSchedulePaneType["AdminSchedule"] = 2] = "AdminSchedule";
    SelfServiceSchedulePaneType[SelfServiceSchedulePaneType["AdminLegacySchedule"] = 3] = "AdminLegacySchedule";
    SelfServiceSchedulePaneType[SelfServiceSchedulePaneType["FlowRunTask"] = 4] = "FlowRunTask";
})(SelfServiceSchedulePaneType = exports.SelfServiceSchedulePaneType || (exports.SelfServiceSchedulePaneType = {}));
/**
 * Top level Self Service Schedule pane component. This class would render the drop-down with top-level
 * options. The recurrence model overlay would have the rest.
 */
var SelfServiceSchedulePane = /** @class */ (function (_super) {
    __extends(SelfServiceSchedulePane, _super);
    function SelfServiceSchedulePane(props, context) {
        var _this = _super.call(this, props, context) || this;
        _this.selfServiceScheduleId = 'self-service-schedule';
        _this.recurrenceModelChangedHandler = function (model) {
            _this.props.recurrenceModelChangedCallback(model);
        };
        _this.doneHandler = function () {
            _this.setShowOptionsOverlay(false);
        };
        // Uses () => function definition to avoid needing to bind "this"
        _this.getRecurrenceOptionsOverlay = function () {
            return React.createElement(RecurrenceOptionsOverlay_1.RecurrenceOptionsOverlay, { onDone: _this.doneHandler, recurrenceModel: _this.props.recurrenceModel, recurrenceModelChangedCallback: _this.recurrenceModelChangedHandler, timeZoneDetails: _this.props.timeZoneDetails, type: _this.props.type === undefined ? SelfServiceSchedulePaneType.Default : _this.props.type, onTimeZoneClick: _this.props.onTimeZoneClick, disableRecurrenceTypes: _this.props.disableRecurrenceTypes });
        };
        _this.state = {
            showOptionsOverlay: false,
            expanded: !!props.uncollapsible,
        };
        return _this;
    }
    SelfServiceSchedulePane.prototype.setShowOptionsOverlay = function (aValue) {
        this.setState({
            showOptionsOverlay: aValue
        });
    };
    SelfServiceSchedulePane.prototype.render = function () {
        var _this = this;
        var ariaLabelledBy = this.props.externalLabelId ? this.props.externalLabelId + ' ' + this.selfServiceScheduleId :
            this.selfServiceScheduleId;
        var expandoSSS = React.createElement(widgets_1.ExpandoWidget, { direction: widgets_1.ExpandoDirection.Down, isExpanded: this.state.expanded, label: CreateOrEditRecurrenceModelMapper_1.LocalizationHelpers.getRecurrenceStringLocalized(this.props.recurrenceModel), id: this.selfServiceScheduleId, "aria-labelledby": ariaLabelledBy, onCollapse: function () { return _this.setState({ expanded: false }); }, onExpand: function () { return _this.setState({ expanded: true }); }, testId: 'show-schedule-details-shared-widget', style: { alignItems: 'stretch' } }, this.getRecurrenceOptionsOverlay());
        return React.createElement(React.Fragment, null, !this.props.uncollapsible
            ? expandoSSS
            : this.getRecurrenceOptionsOverlay());
    };
    ;
    return SelfServiceSchedulePane;
}(React.Component));
exports.SelfServiceSchedulePane = SelfServiceSchedulePane;
//# sourceMappingURL=SelfServiceSchedulePane.js.map